import useInvoice from "@/hooks/useInvoice";
import { Backdrop, Box, CircularProgress, Container } from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { Registration } from "../../api/dtos";

interface InvoiceProps {
    registration: Registration
}


const Invoice = React.forwardRef(({ registration, }: InvoiceProps, ref) => {

    const {invoice, loading} = useInvoice(registration.id);
    const [displayInvoice, setDisplayInvoice] = useState<string>();

    React.useEffect(() => {
        if (!displayInvoice) {
            setDisplayInvoice(invoice);
        }
    }, [invoice, loading]);
    
    return (
        <Container
            maxWidth="lg"
        >
            {
                loading ? 
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={true}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                :
                displayInvoice && (
                    <Box
                        ref={ref}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 4
                        }}
                        dangerouslySetInnerHTML={{ __html: displayInvoice }}
                    />
                )
            }
        </Container>
    );
})

export default Invoice;

